import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck } from "lucide-react";
import { api } from "@/lib/api";

export function useEkycChatSummary() {
  const [sum, setSum] = useState(null);
  useEffect(() => {
    api.get("/ekyc/chat/groups")
      .then(({ data }) => setSum({ groups: data.groups.length, unread: data.groups.reduce((a, g) => a + (g.unread || 0), 0) }))
      .catch(() => setSum({ groups: 0, unread: 0 }));
  }, []);
  return sum;
}

export function EkycChatButton({ className = "" }) {
  const navigate = useNavigate();
  const sum = useEkycChatSummary();
  if (!sum?.groups) return null;
  return (
    <button onClick={() => navigate("/ekyc-desk?view=chat")} data-testid="ekyc-chat-entry"
      className={`relative flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 rounded ${className}`}>
      <BadgeCheck className="w-4 h-4" />
      <span>EKYC Chat</span>
      {sum.unread > 0 && (
        <span className="text-[10px] bg-[#25A244] text-white rounded-full px-1.5 py-0.5 font-bold" data-testid="ekyc-chat-entry-unread">{sum.unread}</span>
      )}
    </button>
  );
}
